import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BetHistoryItem from './BetHistoryListItem';
import Spinner from '../../../../../common/spinner';

const BetHistoryList = ({ isLoading, currencySign, bets }) => (
    <div className="bs-betHistoryList">
        <div className="bs-betHistoryList__title">
            <div>
                <span className="bs-betHistoryList__titleLine">Bet Type</span>
                <span className="bs-betHistoryList__titleLine">Market</span>
            </div>
            <div>
                <span className="bs-betHistoryList__titleLine">Total Stake</span>
                <span className="bs-betHistoryList__titleLine">Return</span>
            </div>
        </div>
        <div className={classNames({ 'bs-betHistoryList__container': bets.length })}>
            {
                bets.map(bet => (
                    <BetHistoryItem
                        {...bet}
                        currencySign={currencySign}
                        key={`${bet.receiptId}_${bet.timeBetPlaced}`}
                    />
                ))
            }
            <Spinner visible={isLoading} className="bs-betHistory__spinner">
                Requesting Bet History data
            </Spinner>
        </div>
    </div>
);

BetHistoryList.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    currencySign: PropTypes.string.isRequired,
    bets: PropTypes.arrayOf(PropTypes.shape({
        finished: PropTypes.bool.isRequired,
        betType: PropTypes.string.isRequired,
        receiptId: PropTypes.string.isRequired,
        returns: PropTypes.number,
        stake: PropTypes.number.isRequired,
        totalStake: PropTypes.number.isRequired,
        timeBetPlaced: PropTypes.string.isRequired,
        win: PropTypes.bool,
        selections: PropTypes.arrayOf(PropTypes.shape({
            eachWay: PropTypes.bool.isRequired,
            eventName: PropTypes.string.isRequired,
            odd: PropTypes.string.isRequired,
            selectionName: PropTypes.string.isRequired,
        })),
    })).isRequired,
};

export default BetHistoryList;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/betHistory/components/BetHistoryList.jsx